import type { GHAScopeRuleCugTier, GHAScopeRuleDiscountType } from '~/services/ConnectionGoogleService';

export { GHA_DISCOUNT_ACCOUNT_TYPE_OPTIONS } from '~/components/GHADiscountConfig/constants';
export { ACCOUNT_LABELS } from '~/components/GHADiscountSummary/constants';

// The Hotel-Center-registered supplier set. Keep in sync with svc-connection-google:
// src/lib/supplierCodes.ts (codes) and src/scripts/generateGhaRateRules.ts SUPPLIERS.
export const GHA_SUPPLIER_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'S1', label: 'Expedia (S1)' },
  { value: 'S2', label: 'Hotelbeds (S2)' },
  { value: 'S3', label: 'WebBeds (S3)' },
  { value: 'S5', label: 'Dida (S5)' },
  { value: 'S14', label: 'Agoda (S14)' },
];

export const GHA_SUPPLIER_LABELS: Record<string, string> = Object.fromEntries(
  GHA_SUPPLIER_OPTIONS.map((option) => [option.value, option.label]),
);

// The scoped tables never speak no_tier — the backend folds NoTier/unclassified to Tier 1, so a
// tier_1 rule already covers untiered properties.
export const GHA_SCOPE_CUG_TIER_OPTIONS: Array<{ value: GHAScopeRuleCugTier; label: string }> = [
  { value: 'tier_1', label: 'Tier 1 (incl. No Tier)' },
  { value: 'tier_2', label: 'Tier 2' },
  { value: 'tier_3', label: 'Tier 3' },
  { value: 'tier_4', label: 'Tier 4' },
];

export const GHA_SCOPE_DISCOUNT_TYPE_OPTIONS: Array<{ value: GHAScopeRuleDiscountType; label: string }> = [
  { value: 'percentage', label: 'Percentage' },
  { value: 'margin_retention', label: 'Margin retention' },
];

export const DISCOUNTING_SECTIONS = ['summary', 'scope-rules', 'exclusions'] as const;
export type DiscountingSection = (typeof DISCOUNTING_SECTIONS)[number];
